export default "__VITE_PUBLIC_ASSET__f095c3ed__"